// extracted by mini-css-extract-plugin
export var deleteModal = "_ee-0";